"use client";

import { ComponentProps, useState } from "react";

import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

import { Button } from "ui/core/button";
import { Table } from "ui/core/table";

import { getChipTableBodyStyles } from "../helpers/chip-table-body-styles";
import { getChipTableHeaderStyles } from "../helpers/chip-table-geader-styles";

const count = 8;

type ChipTableProps = {
  headerData: ComponentProps<typeof Table>["data"][0];
  bodyData: ComponentProps<typeof Table>["data"];
  lang: Lang;
} & ComponentProps<"div">;

export const ChipTable = ({ headerData, bodyData, lang, ...props }: ChipTableProps) => {
  const { t } = getTranslations(lang);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const headerStyles = getChipTableHeaderStyles({ length: headerData.length });
  const bodyStyles = getChipTableBodyStyles({
    length: headerData.length,
  });
  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <div {...props} className="flex flex-col items-center gap-5">
      <div className="w-full overflow-auto">
        <Table
          data={[
            headerData,
            ...(isCollapsed ? bodyData.slice(0, count) : bodyData),
          ]}
          tableHeaderStyles={headerStyles}
          tableCellStyles={bodyStyles}
        />
      </div>
      <Button
        onClick={toggleCollapse}
        variant="secondary"
        className="w-full max-w-xs"
      >
        {isCollapsed
          ? t.analysis.chip.institutionalInvestors.showAll
          : t.analysis.chip.institutionalInvestors.showLess}
      </Button>
    </div>
  );
};
